import {Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {ProjectService} from '../../shared/services/project.service';

@Component({
    selector: 'mbnm-standard-sizes',
    templateUrl: './standard-sizes.component.html',
    styleUrls: ['./standard-sizes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StandardSizesComponent implements OnInit {

  selectedSize: any;

  availableSizes: Array<any> = new Array<any>();

  @Input()
  public filterList: Array<any>;

  @Input()
  public mode = 'STANDARD';

  @Input()
  showOpeningSizes = true;

  @Output('selectionChanged')
  public selectionChangedEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private projectService: ProjectService) {
  }

  onStandardSizeDropDownChange($event) {
    this.selectSize($event.value);
  }

  selectSize(size: any) {
    this.selectedSize = size;
    if (!this.showOpeningSizes) {
      this.selectionChangedEventEmitter.emit({
        outer: size.outer
      });
    } else {
      this.selectionChangedEventEmitter.emit(size);
    }
  }

  ngOnInit() {
    ProjectService.standardSizes.forEach( (size) => {
      // find it in the list (check for uniqueness)
      const matches = this.showOpeningSizes ? [] : this.availableSizes.filter( (sz) => {
        return sz.outer[0] === size.outer[0] && sz.outer[1] === size.outer[1];
      });

      const matchesFilter: boolean = !this.filterList ? true : this.filterList.filter( (sz) => {
        return !this.showOpeningSizes ? sz === size.outer.join('x') : sz === size.outer.join('x') + '-' + size.artwork.join('x');
      }).length === 1;

      // if we haven't already added it and it's marked visible
      if (matches.length === 0 && size.visible && matchesFilter) {
        // if in show kit/bag mode
        if (this.mode === 'SHOWKIT' || this.mode === 'SHOWBAG') {
          // only add ones that support show bags
          if (size.supportsClearBags) {
            this.availableSizes.push(size);
          }
          // otherwise add it
        } else {
          this.availableSizes.push(size);
        }
      }
    });
  }
}
